@if (!data.hideDismiss) {
  <span matSnackBarActions id="notification-action" (click)="closeNotice()">
    <span matSnackBarAction class="crm-industrial-font icon-x-circle"></span>
  </span>
}

<span matSnackBarLabel id="notification-message" [class.notif-clickable]="data.action"
  (click)="data.action && data.action()">
  {{ data.notice }}
</span>